'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteItem = exports.editItem = exports.addItem = exports.deleteImage = exports.addImage = exports.find = exports.findSync = exports.outfeatFound = exports.updateOutfeat = exports.create = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = outfeat;

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ApiClient = require('../../helpers/ApiClient');

var _actionTypes = require('../actionTypes');

var _entities = require('./entities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_IMAGE = 'ADD_IMAGE';
var DELETE_IMAGE = 'DELETE_IMAGE';
var ADD_ITEM = 'ADD_ITEM';
var EDIT_ITEM = 'EDIT_ITEM';
var DELETE_ITEM = 'DELETE_ITEM';

var OUTFEAT_ENDPOINT = '/outfeat/';

var initialState = {
  isLoading: false,
  isCreating: false,
  display: '',
  current: {
    images: [],
    items: []
  }
};

function outfeat() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    // overight cached data. todo, add nested path to persistState.
    case '@@redux/INIT':
      return (0, _extends3.default)({}, state, {
        isLoading: false
      });
    // Creation process
    case ADD_IMAGE:
      return (0, _extends3.default)({}, state, {
        current: (0, _extends3.default)({}, state.current, {
          images: [].concat((0, _toConsumableArray3.default)(state.current.images), [action.image])
        })
      });
    case DELETE_IMAGE:
      var index = state.current.images.findIndex(function (image) {
        return image === action.image;
      });
      if (index === -1) {
        return state;
      }
      return (0, _extends3.default)({}, state, {
        current: (0, _extends3.default)({}, state.current, {
          images: [].concat((0, _toConsumableArray3.default)(state.current.images.slice(0, index)), (0, _toConsumableArray3.default)(state.current.images.slice(index + 1)))
        })
      });
    case ADD_ITEM:
      return (0, _extends3.default)({}, state, {
        current: (0, _extends3.default)({}, state.current, {
          items: [].concat((0, _toConsumableArray3.default)(state.current.items), [action.item])
        })
      });
    case EDIT_ITEM:
      var index = state.current.items.findIndex(function (item) {
        return item.id === action.id;
      });
      if (index === -1) {
        return state;
      }
      return (0, _extends3.default)({}, state, {
        current: (0, _extends3.default)({}, state.current, {
          items: [].concat((0, _toConsumableArray3.default)(state.current.items.slice(0, index)), [action.item], (0, _toConsumableArray3.default)(state.current.items.slice(index + 1)))
        })
      });
    case DELETE_ITEM:
      var index = state.current.items.findIndex(function (item) {
        return item.id === action.id;
      });
      if (index === -1) {
        return state;
      }
      return (0, _extends3.default)({}, state, {
        current: (0, _extends3.default)({}, state.current, {
          items: [].concat((0, _toConsumableArray3.default)(state.current.items.slice(0, index)), (0, _toConsumableArray3.default)(state.current.items.slice(index + 1)))
        })
      });
    // Upload + find process
    case _actionTypes.outfeatActions.CREATE_OUTFEAT.STARTED:
      return (0, _extends3.default)({}, state, {
        isCreating: true
      });
    case _actionTypes.outfeatActions.FIND_OUTFEAT.STARTED:
      return (0, _extends3.default)({}, state, {
        display: action.outfeat_id,
        isLoading: true
      });
    case _actionTypes.outfeatActions.CREATE_OUTFEAT.COMPLETED:
      return (0, _extends3.default)({}, state, {
        isCreating: false,
        current: {
          images: [],
          items: []
        }
      });
    case _actionTypes.outfeatActions.FIND_OUTFEAT.COMPLETED:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        display: action.result.result.outfeats
      });
    case _actionTypes.outfeatActions.CREATE_OUTFEAT.FAILED:
      return (0, _extends3.default)({}, state, {
        isCreating: false,
        current: (0, _extends3.default)({}, state.current, {
          error: action.error
        })
      });
    case _actionTypes.outfeatActions.FIND_OUTFEAT.FAILED:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        display: {
          error: action.error
        }
      });
    default:
      return state;
  }
}

var create = exports.create = function create(data) {
  return function (dispatch, getState) {
    var auth = getState().auth;
    if (auth.user && auth.user.id) {
      data.userId = auth.user.id;
      data.user = {
        username: auth.user.username,
        full_name: auth.user.full_name,
        profile_picture: auth.user.profile_picture,
        id: auth.user.id
      };
    }
    dispatch({
      types: _actionTypes.outfeatActions.CREATE_OUTFEAT.TYPES,
      promise: function promise(client) {
        return client.post(OUTFEAT_ENDPOINT, { data: data });
      }
    });
  };
};

var updateOutfeat = exports.updateOutfeat = function updateOutfeat(outfeatId, updates) {
  return {
    types: _actionTypes.outfeatActions.UPDATE_OUTFEAT.TYPES,
    promise: function promise(client) {
      return client.put(OUTFEAT_ENDPOINT + outfeatId, { data: updates }).then(function (o) {
        return (0, _entities.normalizer)('outfeats', o);
      });
    }
  };
};

var outfeatFound = exports.outfeatFound = function outfeatFound(outfeat) {
  return {
    type: _actionTypes.outfeatActions.FIND_OUTFEAT.COMPLETED,
    result: outfeat
  };
};

var findSync = exports.findSync = function findSync(outfeat_id) {
  return fetch((0, _ApiClient.formatUrl)('/outfeat' + outfeat_id)).then(function (response) {
    return response.json();
  }).then(function (o) {
    return (0, _entities.normalizer)('outfeats', o);
  });
};

var find = exports.find = function find(outfeat_id) {
  return function (dispatch, getState) {
    var outfeat = getState().outfeat;
    if (outfeat.isLoading == true && outfeat_id == outfeat.display) {
      console.log('Minute papillions, je le cherche ton outfeat!');
    } else {
      dispatch({
        types: _actionTypes.outfeatActions.FIND_OUTFEAT.TYPES,
        outfeat_id: outfeat_id,
        promise: function promise(client) {
          return client.get(OUTFEAT_ENDPOINT + outfeat_id).then(function (o) {
            return (0, _entities.normalizer)('outfeats', o);
          });
        }
      });
    }
  };
};

var addImage = exports.addImage = function addImage(image) {
  return {
    type: ADD_IMAGE,
    image: image
  };
};

var deleteImage = exports.deleteImage = function deleteImage(image) {
  return {
    type: DELETE_IMAGE,
    image: image
  };
};

var addItem = exports.addItem = function addItem(item) {
  return {
    type: ADD_ITEM,
    item: item
  };
};

var editItem = exports.editItem = function editItem(id, item) {
  return {
    type: EDIT_ITEM,
    id: id,
    item: item
  };
};

var deleteItem = exports.deleteItem = function deleteItem(id) {
  return {
    type: DELETE_ITEM,
    id: id
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/outfeat.js
 ** module id = 185
 ** module chunks = 0
 **/